import { initFlowbite } from 'flowbite';
import '../../shared/js/shared.js'
import 'cookies.js'

// Flowbite only binds its data-attribute handlers (modals, dropdowns, tooltips)
// on DOMContentLoaded. wire:navigate swaps the page without firing that event,
// so re-initialise on every Livewire navigation (also fires on initial load).
document.addEventListener('livewire:navigated', () => {
    initFlowbite();
});


document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.brand-item') !== null) {
        const links = document.querySelectorAll('.brand-item a.reveal-commissions');

        links.forEach(function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault(); // Voorkom de standaardactie van de link

                const brandItem = link.closest('.brand-item');

                if (brandItem) {
                    const listItems = brandItem.querySelectorAll('ul.commission-flow li');
                    listItems.forEach(function (listItem) {
                        listItem.classList.remove('hidden');
                    });

                    link.remove();
                }
            });
        });
    }

    const targets = document.querySelectorAll('.lyb-timeline-icon');
    const viewportHeight = window.innerHeight;
    const timelineAnimations = () => {
        targets.forEach(target => {
            const rect = target.getBoundingClientRect();
            if (rect.top < viewportHeight / 2) {
                target.classList.add('past-50');
            } else {
                target.classList.remove('past-50');
                target.style.webkitAnimationPlayState = "running"
            }
        });
    };

    // Initial check in case elements are already past 50% on load
    timelineAnimations();

    // Attach the scroll event listener
    window.addEventListener('scroll', timelineAnimations);
});

window.autoResize = function (textarea, maxRows = 6) {
    const style = getComputedStyle(textarea);
    const lineHeight = parseFloat(style.lineHeight) || 20;
    const paddingY = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    const borderY = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    const maxHeight = (lineHeight * maxRows) + paddingY + borderY;

    textarea.style.height = 'auto';
    const newHeight = Math.min(textarea.scrollHeight + borderY, maxHeight);
    textarea.style.height = newHeight + 'px';
    textarea.style.overflowY = (textarea.scrollHeight + borderY) > maxHeight ? 'auto' : 'hidden';
}

window.scrollToBottom = function (el) {
    el.scrollTop = el.scrollHeight;
};